import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchModels, getModels } from '../../modules/models';
import { getMaterials, fetchMaterials } from '../../modules/materials';
import { getScenes, fetchScenes } from '../../modules/scenes';
import { getTags } from '../../modules/tags';
import PropTypes from 'prop-types';
import styles from './Dashboard.module.css';
import ReactSelect from 'react-select';
import { Tab, Tabs, TabList } from 'react-tabs';
import TableView from '../../components/TableView';
import queryString from 'query-string';

class Dashboard extends Component {
  state = {
    selectedIndex: 0,
    headers: ['Product Name', 'Collection Code', 'Item Type Code', 'Status'],
    data: [],
    sortBy: { index: 0, order: 1 },
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  async componentDidMount() {
    const { fetchModels, fetchMaterials, fetchScenes } = this.props;
    const { router } = this.context;
    const query = queryString.parse(router.history.location.search);
    const project = query.project;
    await fetchModels({ project });
    await fetchMaterials({ project });
    await fetchScenes({ project });
  }

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  onSelect = idx => {
    this.setState({ selectedIndex: idx });
  };

  formatData = () => {
    const { router } = this.context;
    const query = queryString.parse(router.history.location.search);
    const { selectedIndex, sortBy } = this.state;
    const { models, materials, scenes } = this.props;
    if (selectedIndex === 0) {
      const data = Object.keys(models)
        .filter(
          item => !query.project || models[item].project === query.project
        )
        .map(k => {
          const v = models[k];
          return [
            { label: v.friendlyName, value: v._id },
            v.metadata['Collection Code'],
            v.metadata['Item Code'],
            v.pipeline,
          ];
        });

      if (sortBy) {
        data.sort((a, b) => {
          if (typeof a[sortBy.index] === 'object') {
            return sortBy.order > 0
              ? a[sortBy.index]['label'] > b[sortBy.index]['label']
                ? 1
                : -1
              : a[sortBy.index]['label'] < b[sortBy.index]['label']
              ? 1
              : -1;
          }
          return sortBy.order > 0
            ? a[sortBy.index] > b[sortBy.index]
              ? 1
              : -1
            : a[sortBy.index] < b[sortBy.index]
            ? 1
            : -1;
        });
      }

      return {
        headers: [
          'Product Name',
          'Collection Code',
          'Item Type Code',
          'Status',
        ],
        data,
      };
    } else if (selectedIndex === 1) {
      const data = Object.keys(materials)
        .filter(
          item => !query.project || materials[item].project === query.project
        )
        .map(k => {
          const v = materials[k];
          return [{ label: v.friendlyName, value: v._id }, v.pipeline];
        });
      if (sortBy) {
        data.sort((a, b) => {
          if (typeof a[sortBy.index] === 'object') {
            return sortBy.order > 0
              ? a[sortBy.index]['label'] > b[sortBy.index]['label']
                ? 1
                : -1
              : a[sortBy.index]['label'] < b[sortBy.index]['label']
              ? 1
              : -1;
          }
          return sortBy.order > 0
            ? a[sortBy.index] > b[sortBy.index]
              ? 1
              : -1
            : a[sortBy.index] < b[sortBy.index]
            ? 1
            : -1;
        });
      }
      return {
        headers: ['Material', 'Status'],
        data,
      };
    } else if (selectedIndex === 2) {
      return {};
    } else if (selectedIndex === 3) {
      return {};
    }
  };

  onHeaderClick = k => {
    const { sortBy } = this.state;
    if (sortBy.index === k) {
      sortBy.order *= -1;
    } else {
      sortBy.index = k;
      sortBy.order = 1;
    }
    this.setState({ sortBy });
  };

  openViewPage = id => {
    const { selectedIndex } = this.state;
    if (selectedIndex === 0) {
      this.navTo(id, 'models');
    } else if (selectedIndex === 1) {
      this.navTo(id, 'materials');
    }
  };

  render() {
    const { models, tags } = this.props;
    if (!models) return null;
    const { headers, data } = this.formatData();
    const { selectedIndex } = this.state;
    return (
      <div className={styles.container}>
        <div className={styles.header}> My Dashboard</div>
        <div className={styles.actionContainer}>
          <div className={styles.tagFilter}>
            <span className={styles.title}>Filter by tag</span>{' '}
            <ReactSelect
              className={styles.tagContainer}
              multi="true"
              options={tags.map(item => item[0])}
            />
          </div>
          <div className={styles.dateRange}>
            <span className={styles.title}> Date Range </span>{' '}
            <ReactSelect
              className={styles.rangeContainer}
              placeholder="Last 7 days"
            />
          </div>
        </div>
        <div className={styles.content}>
          <Tabs onSelect={this.onSelect} selectedIndex={selectedIndex}>
            <TabList>
              {['Models', 'Materials', 'Scenes', 'Renderings'].map(v => (
                <Tab
                  style={{
                    width: 80,
                    height: 40,
                    textAlign: 'center',
                    borderRadius: 0,
                  }}
                >
                  <span className={styles.tabTitle}>{v}</span>
                </Tab>
              ))}
            </TabList>
          </Tabs>
          <div className={styles.actionContainer}>
            <ReactSelect
              className={styles.bulkActions}
              placeholder="Bulk Actions"
            />
            <div className={styles.dateRange}>
              <span className={styles.title}>Sort By </span>{' '}
              <ReactSelect
                className={styles.rangeContainer}
                value="recent"
                options={[{ label: 'Most Recent', value: 'recent' }]}
              />
            </div>
          </div>
          {data ? (
            <TableView
              rowColor="#2375C2"
              headerColor="#2375C2"
              headers={headers}
              data={data}
              onClick={this.openViewPage}
              onHeaderClick={this.onHeaderClick}
            />
          ) : (
            <p className={styles.noContent}>
              There are no scenes currently assigned to you
            </p>
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({
    models: getModels(state),
    materials: getMaterials(state),
    scenes: getScenes(state),
    tags: getTags(state),
  }),
  { fetchModels, fetchScenes, fetchMaterials }
)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js